import { ApiCallWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('ApiCall')
export class ApiCallNodeConnectorProvider extends ConnectorProvider<ApiCallWorkflowNode> {}
